import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = 'https://api.civilcadpro.in/api';

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    fetchStats();
    fetchAnalytics();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/dashboard`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAnalytics = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/analytics/stats?days=30`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAnalytics(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  if (!stats || !analytics) return <div className="card">Loading...</div>;

  return (
    <div>
      <h2 style={{ marginBottom: 25, color: '#1a1a2e' }}>Dashboard</h2>
      
      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="stat-card orange">
          <h3>{stats.totalCustomers}</h3>
          <p>Total Customers</p>
        </div>
        <div className="stat-card green">
          <h3>{stats.activeLicenses}</h3>
          <p>Active Licenses</p>
        </div>
        <div className="stat-card red">
          <h3>{stats.pendingRequests}</h3>
          <p>Pending Requests</p>
        </div>
        <div className="stat-card blue">
          <h3>{analytics.activeToday}</h3>
          <p>Active Today</p>
        </div>
      </div>

      {/* Usage Stats */}
      <div className="card">
        <h2>Command Usage (Last 30 Days)</h2>
        {analytics.topCommands.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#888', padding: 30 }}>No usage data yet</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Command</th>
                <th>Times Used</th>
                <th>Bar</th>
              </tr>
            </thead>
            <tbody>
              {analytics.topCommands.slice(0, 15).map((cmd, idx) => (
                <tr key={cmd._id}>
                  <td>{idx + 1}</td>
                  <td><strong>{cmd._id}</strong></td>
                  <td>{cmd.count.toLocaleString()}</td>
                  <td>
                    <div style={{
                      width: `${(cmd.count / analytics.topCommands[0].count) * 100}%`,
                      height: 20,
                      background: 'linear-gradient(90deg, #ec700b, #2ea043)',
                      borderRadius: 10,
                      minWidth: 30
                    }} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <p style={{ marginTop: 15, color: '#888', fontSize: 13 }}>
          Total commands run: <strong>{analytics.totalCommands.toLocaleString()}</strong>
        </p>
      </div>

      {/* Per License Usage */}
      <div className="card">
        <h2>Top Users</h2>
        {analytics.perLicense.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#888', padding: 30 }}>No user data yet</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>License ID</th>
                <th>Commands Run</th>
                <th>Last Active</th>
              </tr>
            </thead>
            <tbody>
              {analytics.perLicense.map(user => (
                <tr key={user._id}>
                  <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{user._id}</td>
                  <td><strong>{user.count.toLocaleString()}</strong></td>
                  <td>{new Date(user.lastUsed).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Dashboard;